// extracted by mini-css-extract-plugin
export default {"component":"full-loader_component__D8FT9"};